import { render, staticRenderFns } from "./SecurityServerTlsCertificate.vue?vue&type=template&id=12c2d371&scoped=true&"
import script from "./SecurityServerTlsCertificate.vue?vue&type=script&lang=ts&"
export * from "./SecurityServerTlsCertificate.vue?vue&type=script&lang=ts&"
import style0 from "./SecurityServerTlsCertificate.vue?vue&type=style&index=0&id=12c2d371&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c2d371",
  null
  
)

export default component.exports